<template>
    <PostingModule
        :label="label"
        :data="data()"
        :isLoading="loading()"
        :estimatedJobsLeft="estimatedJobsLeft"
        noToggles
        :smallView="smallView"
        :restrictHeight="restrictHeight"
    >
        <div v-if="data().length > 0" class="p-2">
            <BaseButton class="w-100" variant="secondary" @click="viewAllJobs">
                {{
                    $t('companyDetail.jobModule.viewAllJobs', {
                        companyName: companyName,
                    })
                }}
            </BaseButton>
        </div>
        <div
            slot="empty"
            class="pa-2 d-flex flex-column align-items-center justify-content-center"
        >
            <img :src="noResult" class="no-result-image mt-2 mb-3" />
            <p class="text-center">
                {{
                    $t('companyDetail.jobModule.noPositions', {
                        companyName: companyName,
                    })
                }}
            </p>
        </div>
    </PostingModule>
</template>

<script>
import PostingModule from '~/shared/postingmodule/PostingModule';
import EmptySvg from '~/assets/img/empty.svg';
import i18n from '~/i18n';

export default {
    name: 'JobModule',
    components: { PostingModule },
    props: {
        companyId: {
            type: [String, Number, Array],
        },
        companyName: {
            type: [String, Number],
        },
        label: {
            type: String,
            optional: true,
            default: i18n.t('companyDetail.jobModule.defaultLabel'),
        },
        smallView: Boolean,
        restrictHeight: {
            type: Number,
            optional: true,
        },
        searchUsingCompanyName: Boolean,
        redirectUsingCompanyName: Boolean,
        redirectUsingQuery: Boolean,
    },
    data: () => ({
        noResult: EmptySvg,
    }),
    computed: {
        customSearch() {
            return this.searchUsingCompanyName
                ? { query: this.companyName }
                : this.companyId
                ? { company_id: this.companyId }
                : {};
        },
        redirectValues() {
            return this.redirectUsingCompanyName
                ? ['?company_name=', this.companyName]
                : this.redirectUsingQuery
                ? ['?query=', this.companyName]
                : ['?company_id=', this.companyId];
        },
        companyJobs() {
            if (!this.companyId) {
                return [];
            }

            return this.$interfaces.posting.get({
                reactive: true,
                ...this.customSearch,
            });
        },

        estimatedJobsLeft() {
            if (this.companyJobs instanceof Array) {
                return;
            } else if (this.companyJobs.loading) {
                return;
            }

            return this.companyJobs.queryInfo.estimatedJobsLeft;
        },
    },
    methods: {
        data() {
            return (this.companyJobs.data || []).slice(0, 5);
        },
        loading() {
            if (!this.companyId) {
                return true;
            }

            return this.companyJobs.loading === undefined
                ? true
                : this.companyJobs.loading;
        },
        error() {
            return this.companyJobs.error;
        },
        viewAllJobs() {
            let [key, value] = this.redirectValues;
            this.$emit('click');
            this.$router.push(this.$URLS.findjobs.concat(key, value));
        },
    },
};
</script>

<style scoped>
.no-result-image {
    max-width: 100px;
    height: 100px;
    max-height: 100px;
    object-fit: scale-down;
}
</style>
